import React from 'react';
import './header.css'
import pic10 from '../../assets/pic10.png'
import pic11 from '../../assets/pic11.png'
import pic12 from '../../assets/pic12.png'
import pic13 from '../../assets/pic13.png'
import logo from '../../assets/logo.png'


const Header = ( { onMenuClick }) => {
    return ( 
        <header className='header'>
            <nav className='container-info-header'>
                <button className='button-notification'>
                    <img src={pic10} alt='pic'></img>
                </button>
                <article className='container-profile'>
                    <img src={pic11} alt='pic'></img>
                    <article className='container-text-profile'>
                        <h2 className='admintext'>Admin User</h2>
                        <h3 className='adminemail'>admin@musicticket.com</h3>
                    </article>
                </article>

                                    <button className='cta-hedaer'>
                        <img src={pic12} alt='pic'></img>
                            <h2 className="lang">عربي</h2>
                    </button>

            
            </nav>

            <img className='logo2' src={logo} alt="logo"></img>
                            <button className='burger-menu' onClick={onMenuClick}>
                      <img src={pic13} alt="menu" />
                </button>
        </header>
     );
}
 
export default Header;